import React, { useState, useEffect } from "react";
import { Link, NavLink, Navigate } from "react-router-dom";
import { Navbar, Nav, Offcanvas, Button } from "react-bootstrap";
import {
  FaDice,
  FaHorse,
  FaHorseHead,
  FaRegEye,
  FaRocket,
  FaTrophy,
  FaUser,
  FaUserPlus,
} from "react-icons/fa";
import { BiCricketBall, BiFootball, BiSolidTennisBall } from "react-icons/bi";
import { ImSpades } from "react-icons/im";
import { PiMonitorPlay } from "react-icons/pi";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Header.css";
// import "../../../src/App.css";
import LoginPopup from "../LoginPopup/LoginPopup";
import AccountStatus from "../AccountStatus/AccountStatus";
import { useNavigate } from "react-router-dom";
import Helper from "../../helper";
import { useAuth } from "../AuthContext";
import Appconfig from "../../config/config";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { emptyUserInfo } from "../../redux/slice/userInfo/userInfoSlice";
import SignUp from "../SignUp/SignUp";
import Login from "../Login/Login";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { toast } from "react-toastify";
import UserAutoLogout from "../userAutoLogout";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import ScrollGames from "../ScrollGames/ScrollGames";
// import { FaUser } from "react-icons/fa";  
import News from "../News/news";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";


const Header = ({ whatsappNum }) => {

  const navigate = useNavigate();
  const userInfo = Helper();
  const { logout, betPlaced, setBetPlaced } = useAuth();
  const betData = useSelector((state) => state.data); // Use selector to access state
  // console.log("betData in header:", betData);
  const dispatch = useDispatch();
  UserAutoLogout();
  const [showOffcanvas, setShowOffcanvas] = useState(false); // Right slider
  const [showMenu, setShowMenu] = useState(false); // Left slider
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showDeposit, setShowDeposit] = useState(false);
  const [showMyMarkets, setShowMyMarkets] = useState(false);
  const [showCricketList, setShowCricketList] = useState(false);
  const [showFootballList, setShowFootballList] = useState(false);
  const [showTennisList, setShowTennisList] = useState(false);
  const [showHorseRacingList, setShowHorseRacingList] = useState(false);
  const [showGrayHoundRacingList, setShowGrayHoundRacingList] = useState(false);
  const [showIndianCardGamesList, setShowIndianCardGamesList] = useState(false);
  const [showLoginModel, setShowLoginModel] = useState(false);
  const [showSignupModel, setShowSignupModel] = useState(false);
  const [showForgotModel, setShowForgotModel] = useState(false);
  // const [whatsappNum, setWhatsAppNumber] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);

  let balanceWithExp = balance - Math.abs(exposure);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
      if (window.innerWidth > 991) {
        setShowMenu(true); // Always show sidebar on desktop
      } else {
        setShowMenu(false); // Hide sidebar on mobile
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // console.log("userInfo", userInfo);
  }, [userInfo]);

  useEffect(() => {
    if (userInfo) {
      getBalance();
      setBetPlaced(false);
    }

  }, [userInfo, betPlaced]);

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });


    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {

          setBalance(response.data.resultData?.balance);
          setExposure(response.data.resultData?.exposure);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // console.log("balanceWithExp", getBalance());

  const handleLogout = () => {
    handleClose();
    logout();
  };

  const handleToggleMenu = () => {
    if (showOffcanvas) {
      setShowOffcanvas(false); // Close the right slider if it's open
    }
    setShowMenu(!showMenu);
  };

  const handleUserClick = () => {
    if (showMenu) {
      setShowMenu(false); // Close the left slider if it's open
    }
    setShowOffcanvas(true);
  };

  const handleClose = () => {
    setShowOffcanvas(false);
  };

  const handleLoginPopupClick = () => {
    setShowLoginPopup(true); // Show the login popup
  };

  const handleLoginPopupClose = () => {
    setShowLoginPopup(false); // Hide the login popup
  };

  const handleDeposit = () => {
    setShowDeposit(true);
    navigate("/deposit");
  };
  const handleMyMarkets = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleAviator = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`SPB`, `aviator`);
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleCricketList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleFootballList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleTennisList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleHorseRacingList = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`BT`);
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleGrayHoundRacingList = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`BT`);
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleIndianCardGamesList = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`BT`);
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        }

        if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error("Game Not Found.", { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function OpenEzugiLobby(casinoType) {
    if (userInfo) {
      handleToggleMenu();
      navigate("/all-games-lobby", { state: { activeCasino: casinoType } });
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  }

  // const getWhatsAppNumber = () => {
  //   var data = JSON.stringify({
  //     site_code: Appconfig.sitecodes,
  //   });
  //   var config = {
  //     method: "post",
  //     url: `${Appconfig.apiUrl}numbers/getNumberBySiteCode`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };
  //   axios(config)
  //     .then(function (response) {
  //       try {
  //         if (response.data.result) {
  //           console.log("response data for number", response.data?.resultData);

  //           // setWhatsAppNumber(response.data?.resultData?.mob_num);
  //         }
  //       } catch (e) {
  //         // postErrorToslack(e.message);
  //       }
  //     })
  //     .catch(function (error) {
  //       // postErrorToslack(error.message);
  //       console.log(error);
  //     });
  // };


  const openWhatsApp = (whatsapp) => {
    const url = `https://wa.me/${whatsapp.replace(/\D/g, "")}`;
    window.open(url, "_blank");
  };

  const checkNewLogin = () => {
    var data = JSON.stringify({
      login_token: userInfo.login_token,
      user_id: userInfo._id,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}userToken/getToken`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          if (response.data.result) {
          } else {
            localStorage.clear();
            localStorage.removeItem("userdata");
            dispatch(emptyUserInfo());
            localStorage.removeItem("login_token");
            window.location.href = "/";
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        // postErrorToslack(error.message);
        console.log(error);
      });
  };

  // useEffect(() => {
  //   getWhatsAppNumber();
  // }, []);

  // useEffect(() => {
  //   const chkLog = window.setInterval(function () {
  //     if (userInfo) {
  //       checkNewLogin();
  //     }
  //   }, 5000);
  //   return () => {
  //     clearInterval(chkLog)
  //   }
  // }, [])

  const togglePopup = (isClose = null) => {
    if (isClose == "Yes") {
      setShowLoginModel(false);
    } else {
      setShowLoginModel(!showLoginModel);
    }
    setShowForgotModel(false);
    setShowSignupModel(false);
    setShowMenu(false);
  };

  const toggleForgotPopup = () => {
    setShowLoginModel(false);
    setShowSignupModel(false);
    setShowForgotModel(!showForgotModel);
    setShowMenu(false);
  };

  const toggleSignUpPopup = () => {
    setShowLoginModel(false);
    setShowForgotModel(false);
    setShowSignupModel(!showSignupModel);
    setShowMenu(false);
  };

  return (
    <>
      <Login
        showPopup={showLoginModel}
        togglePopup={togglePopup}
        whatsappNum={whatsappNum}
        openWhatsApp={openWhatsApp}
        toggleForgotPopup={toggleForgotPopup}
        toggleSignUpPopup={toggleSignUpPopup}
        handleClose={handleClose}
      />
      <ForgotPassword
        showForgotPopup={showForgotModel}
        togglePopup={togglePopup}
        toggleForgotPopup={toggleForgotPopup}
        handleClose={handleClose}
      />
      <SignUp
        showSignupPopup={showSignupModel}
        togglePopup={togglePopup}
        whatsappNum={whatsappNum}
        openWhatsApp={openWhatsApp}
        toggleSignUpPopup={toggleSignUpPopup}
        handleClose={handleClose}
      />

      <Navbar
        variant="dark"
        expand="lg"
        fixed="top"
        className={userInfo ? "sticky-header" : "sticky-header"}
      >
        <div className="h-[66px] d-flex align-items-center">
          {/* Hamburger Menu Button on the Left Side */}
          {isMobile && (
            <Button
              className={`navbar-toggler me-2 hamburger ${showMenu ? "open" : ""
                }`}
              type="button"
              onClick={handleToggleMenu}
              aria-controls="navbarSupportedContent"
              aria-expanded={showMenu}
              aria-label="Toggle navigation"
              style={{
                background: "transparent",
                border: "none",
                boxShadow: "none",
                outline: "none",
                padding: 0,
                marginRight: "0.5rem",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                marginLeft: "8px",
              }}
            >
              <div className="bar1"></div>
              <div className="bar2"></div>
              <div className="bar3"></div>
            </Button>
          )}
          <Link className="navbar-brand w-full" to={'/'} state={{ myKey: "home" }} >
            <img className="header-logo" src="/Images/logo.png" alt="" style={{
              width: "133px",
              height: "66px",
              objectFit: "contain",
            }} />
          </Link>
          <div className="user-section">
            {userInfo ? (
              <>
                <div className="header-buttons-container">
                  {/* Deposit Button */}
                  {/* <div className="deposit-container">
                    <button className="btn deposit-btn" onClick={handleDeposit}>
                      Deposit
                    </button>
                  </div> */}

                  <div className="flex flex-col gap-2" onClick={handleUserClick}>
                    <div className="flex-row  justify-center items-center text-white text-xs  " >
                      <button
                        className="rounded gap-1 py-1 px-3  w-[80px] text-center text-[11px] flex items-center gap-1 font-bold 6 whitespace-nowrap bg-[#5ecbdd] bg-gradient-to-b from-[#5ecbdd] to-[#146578] borders "

                      > <img src="\Images\coin.svg" className="w-3" />
                        Bal   {balance && Number(balanceWithExp).toFixed(2)}{" "}
                      </button>
                      {/* <span className="mWallet">
                        {balance && Number(balanceWithExp).toFixed(2)}{" "}
                      </span> */}
                    </div>
                    <div className="flex    justify-center items-center text-white text-xs ">
                      {/* <span
                        className="flex justify-center items-center w-8 p-2 text-center bg-[#C10930]"
                        style={{ borderRadius: "0px 0px 10px 10px" }}
                      >
                        Exp.
                      </span> */}
                      <button
                        className="rounded py-1  px-3  w-[80px]  6 text-[11px]  items-center gap-1 font-bold  whitespace-nowrap bg-[#5ecbdd] bg-gradient-to-b from-[#5ecbdd] to-[#146578] borders "

                      >
                        Exp:  {exposure && Number(exposure).toFixed(2)}

                      </button>
                      <span className="mWallet">
                        {/* {exposure && Number(exposure).toFixed(2)} */}
                      </span>
                    </div>
                  </div>

                  {/* User Name */}
                  {/* <div className="username-container" onClick={handleUserClick}>
                    <span
                      className="user-name"
                      title={userInfo?.user_name || "User"}
                    >
                      {userInfo?.user_name || "DemoUser"}
                    </span>
                  </div> */}

                  {/* User Icon */}
                  {/* <div className="icon-container" onClick={handleUserClick}>
                    <FaUser className="user-icon" />
                  </div> */}
                </div>
              </>
            ) : (
              <>
                {/* <button type='button' className="login-btn-header" onClick={() => setShowLoginModel(true)}>
                    <span>Login</span>
                  </button> */}
                {/* <button type='button' className="signUp-btn-header" onClick={() => setShowSignupModel(true)}>
                    <span>Sign Up</span>
                  </button> */}
                <div
                  className="  w-fit p-[1px] rounded "
                  onClick={() => setShowSignupModel(true)}
                >
                  <button
                    className="rounded py-2 px-3 flex items-center gap-1  whitespace-nowrap bg-[#5ecbdd] bg-gradient-to-b from-[#5ecbdd] to-[#146578] borders "

                  >
                    <FontAwesomeIcon icon={faUserPlus} className="text-[11px]" />
                    <span className="font-bold text-[10px]">Sign Up</span>
                  </button>
                </div>
                <div
                  className="  p-[1px] rounded md:ml-1 ml-2 "
                  onClick={() => setShowLoginModel(true)}
                >
                  <button
                    className="rounded py-2 px-3 flex items-center gap-1 font-bold text-[10px] whitespace-nowrap bg-[#5ecbdd] bg-gradient-to-b from-[#5ecbdd] to-[#146578] borders "
                  // style={{
                  //   background: "rgb(0, 70, 135)",
                  //   color: "rgb(255, 255, 255)",
                  // }}
                  >
                    <FaUser />
                    LOGIN
                  </button>
                </div>
                {userInfo && (
                  <button onClick={handleUserClick} className="user-button">
                    <FaUser
                      size={15}
                      color="white"
                      style={{ marginLeft: 1, marginRight: 1, marginBottom: 5 }}
                      className="fa-user"
                    />
                  </button>
                )}
              </>
            )}
          </div>
          {/* <div className="user-section">
            {
              userInfo &&
              <button className="button-30" role="button" onClick={handleDeposit}>Deposit</button>
            }
            <button onClick={handleUserClick} className='user-button'>
              {
                userInfo ?
                  <span className='user-name' title={userInfo ? userInfo?.user_name : ''}>{userInfo ? userInfo?.user_name : ''}</span>
                  :
                  ''
              }
              <FaUser size={15} color="white" style={{ marginLeft: 1, marginRight: 1, marginBottom: 5 }} className='fa-user' />
            </button>
          </div> */}
        </div>
        {/* {userInfo && <ExposureHeader />} */}
        {/* <ScrollGames /> */}
      </Navbar >
      <div>{userInfo && <News />}</div>

      {/* Offcanvas menu for mobile (Left Slider) */}
      {/* <Offcanvas show={showMenu} onHide={handleToggleMenu} placement="start"> */}
      {/* <Offcanvas
        show={showMenu}
        onHide={isMobile ? handleToggleMenu : undefined}
        placement="start"
        backdrop={isMobile}
        scroll={!isMobile}
        className={isMobile ? "" : "desktop-sidebar"}
        style={isMobile ? {} : { width: 250, position: 'fixed', top: 56, height: '100vh', zIndex: 1040 }}
      >
        <Offcanvas.Header closeButton>
        <Offcanvas.Header closeButton={isMobile}>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item active">
                <button className="nav-link" onClick={() => navigate('/openbets')}><FaRegEye size={30} color="black" style={{ marginRight: 10 }} />My markets</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleAviator}><FaRocket size={30} color="Orange" style={{ marginRight: 10 }} />Aviator</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/cricketlist')}><BiCricketBall size={30} color="#900C3F" style={{ marginRight: 10 }} />Cricket</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/football-list')}><BiFootball size={30} color="black" style={{ marginRight: 10 }} />Football</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/tennislist')}><BiSolidTennisBall size={30} color="green" style={{ marginRight: 10 }} />Tennis</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleHorseRacingList}><FaHorseHead size={30} color="black" style={{ marginRight: 10 }} />Horce Racing</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleGrayHoundRacingList}><FaHorse size={30} color="brown" style={{ marginRight: 10 }} />Grayhound Racing</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => CreateAndLaunchWCOCasino('EZ', '', '')}><ImSpades size={30} color="black" style={{ marginRight: 10 }} />Indian Card Games</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleIndianCardGamesList}><FaTrophy size={30} color="#ffd133" style={{ marginRight: 10 }} />Sportsbook (80+)</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/ezugiLobby')}><PiMonitorPlay size={30} color="black" style={{ marginRight: 10 }} />Casino</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/ezugiLobby', { state: { activeCasino: 'Spribe' } })}><FaDice size={30} color="red" style={{ marginRight: 10 }} />Slot Games</button>
              </li>
            </ul>
          </Nav>
          {showLoginPopup && <LoginPopup onClose={handleLoginPopupClose} />}
        </Offcanvas.Body>
      </Offcanvas> */}

      {/* Fullscreen Offcanvas for Account Status (Right Slider) */}
      <Offcanvas
        show={showOffcanvas}
        onHide={handleClose}
        placement="end"
        className="offcanvas-fullscreen"
      >
        <Offcanvas.Header className="bg-[#045662] text-white">
          <button
            onClick={handleClose}
            className="text-white  font-bold text-2xl text-[34px] font-bold absolute right-4 top-[10px]"
          >
            ×
          </button>

          {/* <Offcanvas.Title>Account Status</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AccountStatus
            handleLogout={handleLogout}
            handleClose={handleClose}
            userInfo={userInfo}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Sidebar Menu */}
      {
        (showMenu || !isMobile) && (
          <div className={`sidebar-menu ${!userInfo ? 'block lg:hidden' : 'block'}`}>
            <div className="sidebar-bg">
              {/* Show close button only on mobile */}
              {isMobile && (
                <button className="sidebar-close" onClick={handleToggleMenu}>
                  ×
                </button>
              )}
              <div className="sidebar-content">
                <span className=" w-full bg-[#27a6c3] text-[14px] pt-[2px] py-[7px] text-white flex" style={{ fontWeight: "700", }}>
                  <span className="ml-2" >Popular</span>

                  {/* <button className="sidebar-close text-black " onClick={handleToggleMenu}>
                  ×
                </button> */}
                </span>
                <nav className="sidebar-nav">
                  <Link
                    to={"/"}
                    className=""
                    onClick={() => handleToggleMenu()}

                  >
                    <div role="button" tabIndex={0} className="sidebar-link"
                      style={{ color: "#045662" }}>

                      <div className="sidebar-icon">
                        {/* Home SVG */}

                        <span className="home-icon"></span>

                      </div>
                      Home
                    </div>
                    <hr className="sidebar-divider" />

                  </Link>
                  <Link to={'/'} state={{ myKey: "inplay" }} onClick={() => handleToggleMenu()} style={{ color: "#045662" }}>
                    <div role="button" tabIndex={0} className="sidebar-link border-b-2 border-[#045662]">
                      <div className="sidebar-icon">
                        <span className="dummy-icon-in-play "></span>
                      </div>
                      In-Play
                    </div>
                    <hr className="sidebar-divider" />
                  </Link>
                  {/* ...add more menu items here... */}
                  <Link to={userInfo ? "/cricketlist" : ""}
                    onClick={() => {
                      handleToggleMenu();
                      if (!userInfo) {
                        setShowLoginModel(true);
                        return;
                      }
                    }}>
                    <div role="button" tabIndex={0} className="sidebar-link">
                      <div className="sidebar-icon">
                        <span className="dummy-icon2"></span>
                      </div>
                      Cricket
                    </div>
                    <hr className="sidebar-divider" />

                  </Link>
                  <Link to={"/football-list"} onClick={() => handleToggleMenu()} style={{ color: "#045662" }}>
                    <div role="button" tabIndex={0} className="sidebar-link">
                      <div className="sidebar-icon">
                        <span className="dummy-icon-soccer"></span>
                      </div>
                      Soccer
                    </div>
                    <hr className="sidebar-divider" />

                  </Link>
                  <Link to={"/tennislist"} onClick={() => handleToggleMenu()} style={{ color: "#045662" }}>
                    <div role="button" tabIndex={0} className="sidebar-link">
                      <div className="sidebar-icon">
                        <span className="dummy-icon5"></span>
                      </div>
                      Tennis
                    </div>
                    <hr className="sidebar-divider" />

                  </Link>
                  {/* <div
                  role="button"
                  tabIndex={0}
                  className="sidebar-link"
                  onClick={() => setShowLoginModel(true)} style={{ color: "#045662" }} >
                  <div className="sidebar-icon">
                    <span className="dummy-icon6">  </span>

                  </div>
                  Horse
                </div>
                <hr className="sidebar-divider" /> */}

                  {/* <div
                  role="button"
                  tabIndex={0}
                  className="sidebar-link"
                  onClick={() => OpenEzugiLobby("ezugi")}
                  style={{ color: "#045662" }} >
                  <div className="sidebar-icon">
                    <span className="dummy-icon7"></span>
                  </div>
                  Greyhound
                </div>
                <hr className="sidebar-divider" /> */}

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("mac888")}
                  >
                    <div className="sidebar-icon">
                      <span className="dummy-icon8"> </span>

                    </div>
                    Ludo Cricket
                  </div>
                  <hr className="sidebar-divider" />

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("ezugi")}
                    style={{ color: "#045662" }}  >
                    <div className="sidebar-icon">
                      <span className="dummy-icon8"> </span>

                    </div>
                    Indian Poker
                  </div>
                  <hr className="sidebar-divider" />

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("ezugi")}
                    style={{ color: "#045662" }}  >
                    <div className="sidebar-icon">
                      <span className="dummy-icon9"></span>
                    </div>
                    Indian Poker II
                  </div>
                  <hr className="sidebar-divider" />

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("sn")}
                    style={{ color: "#045662" }}   >
                    <div className="sidebar-icon">
                      <img class="avator-design dummy-icons " src="https://radheexch.app/assets/images/aviator-icon.svg"></img>
                    </div>
                    Aviator
                  </div>
                  <hr className="sidebar-divider" />

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("sn")}
                    style={{ color: "#045662" }}  >
                    <div className="sidebar-icon">
                      <span className="dummy-icon8"> </span>

                    </div>
                    AE SEXY
                  </div>
                  <hr className="sidebar-divider" />

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("evolution")}
                    style={{ color: "#045662" }}  >
                    <div className="sidebar-icon">
                      <span className="dummy-icon12"> </span>

                    </div>
                    Evolution
                  </div>
                  <hr className="sidebar-divider" />

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("sn")}
                  >
                    <div className="sidebar-icon">
                      <span className="dummy-icon8"> </span>
                    </div>
                    Live Casino
                  </div>
                  <hr className="sidebar-divider" />

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("sn")}
                    style={{ color: "#045662" }}   >
                    <div className="sidebar-icon">
                      <span className="dummy-icon12"> </span>
                    </div>
                    VIVO
                  </div>
                  <hr className="sidebar-divider" />

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("sn")}
                    style={{ color: "#045662" }}  >
                    <div className="sidebar-icon">
                      <span className="dummy-icon12"> </span>
                    </div>
                    betgames
                  </div>
                  <hr className="sidebar-divider" />

                  <div
                    role="button"
                    tabIndex={0}
                    className="sidebar-link"
                    onClick={() => OpenEzugiLobby("sn")}
                    style={{ color: "#045662" }} >
                    <div className="sidebar-icon">
                      <span className="dummy-icon8"> </span>
                    </div>
                    Caino III
                  </div>
                  <hr className="sidebar-divider" />

                  {/* <div
                  role="button"
                  tabIndex={0}
                  className="sidebar-link"
                  onClick={() => OpenEzugiLobby("evolution")}
                >
                  <div className="sidebar-icon">
                    <svg
                      _ngcontent-jaa-c28=""
                      className="svgicon ng-star-inserted"
                      hight="22px"
                      style={{
                        padding: 0,
                        margin: 0,
                        height: 17,
                        marginRight: 4,
                      }}
                      viewBox="0 0 18.12 15.42"
                      width="22px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs _ngcontent-jaa-c28="">
                        <style
                          _ngcontent-jaa-c28=""
                          dangerouslySetInnerHTML={{
                            __html:
                              ".cls-1ssss,.cls-2ssss{fill:#045662;}.cls-2{stroke:#000;stroke-miterlimit:10;}",
                          }}
                        />
                      </defs>
                      <g _ngcontent-jaa-c28="" data-name="Layer 2" id="Layer_2">
                        <g
                          _ngcontent-jaa-c28=""
                          data-name="Layer 1"
                          id="Layer_1-2"
                        >
                          <polygon
                            _ngcontent-jaa-c28=""
                            className="cls-1ssss"
                            points="8.49 11.25 7.25 11.25 2.02 3.03 3.25 3.03 8.49 11.25"
                          />
                          <rect
                            _ngcontent-jaa-c28=""
                            className="cls-2ssss"
                            height="14.42"
                            rx="2.57"
                            width="10.92"
                            x="6.7"
                            y="0.5"
                          />
                          <rect
                            _ngcontent-jaa-c28=""
                            height="4.61"
                            rx="0.95"
                            width="1.91"
                            x="7.92"
                            y="5.4"
                          />
                          <rect
                            _ngcontent-jaa-c28=""
                            height="4.61"
                            rx="0.95"
                            width="1.91"
                            x="11.21"
                            y="5.4"
                          />
                          <rect
                            _ngcontent-jaa-c28=""
                            height="8.47"
                            rx="0.95"
                            transform="translate(24.01 -0.31) rotate(90)"
                            width="1.91"
                            x="11.21"
                            y="7.62"
                          />
                          <rect
                            _ngcontent-jaa-c28=""
                            height="4.61"
                            rx="0.95"
                            width="1.91"
                            x="14.49"
                            y="5.4"
                          />
                          <circle
                            _ngcontent-jaa-c28=""
                            className="cls-2ssss"
                            cx="2.52"
                            cy="2.52"
                            r="2.02"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                  Evolution
                </div> */}
                  {/* <div role="button" tabIndex={0} className="sidebar-link">
                  <div className="sidebar-icon">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 512 512"
                      className="h-5 w-5"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M260.062 32C138.605 32 40.134 129.701 40.134 250.232c0 41.23 11.532 79.79 31.559 112.687L32 480l121.764-38.682c31.508 17.285 67.745 27.146 106.298 27.146C381.535 468.464 480 370.749 480 250.232 480 129.701 381.535 32 260.062 32zm109.362 301.11c-5.174 12.827-28.574 24.533-38.899 25.072-10.314.547-10.608 7.994-66.84-16.434-56.225-24.434-90.052-83.844-92.719-87.67-2.669-3.812-21.78-31.047-20.749-58.455 1.038-27.413 16.047-40.346 21.404-45.725 5.351-5.387 11.486-6.352 15.232-6.413 4.428-.072 7.296-.132 10.573-.011 3.274.124 8.192-.685 12.45 10.639 4.256 11.323 14.443 39.153 15.746 41.989 1.302 2.839 2.108 6.126.102 9.771-2.012 3.653-3.042 5.935-5.961 9.083-2.935 3.148-6.174 7.042-8.792 9.449-2.92 2.665-5.97 5.572-2.9 11.269 3.068 5.693 13.653 24.356 29.779 39.736 20.725 19.771 38.598 26.329 44.098 29.317 5.515 3.004 8.806 2.67 12.226-.929 3.404-3.599 14.639-15.746 18.596-21.169 3.955-5.438 7.661-4.373 12.742-2.329 5.078 2.052 32.157 16.556 37.673 19.551 5.51 2.989 9.193 4.529 10.51 6.9 1.317 2.38.901 13.531-4.271 26.359z"></path>
                    </svg>
                  </div>
                  Whatsapp
                </div> */}
                </nav>
              </div>
            </div>
          </div >
        )
      }
    </>
  );
};

export default Header;
